import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { LensLineageCountsFragmentGql } from './LensLineageCountsFragmentGql';

export const LensLineageCountsQueryGql: DocumentNode = gql`
query LensLineageCountsQuery($vizportalUrlId: String!) {
  lenses(filter: { vizportalUrlId: $vizportalUrlId }) {
    ...LensLineageCountsFragment
  }
}
${LensLineageCountsFragmentGql}
`;
